import React, { useEffect, useState } from 'react';
import logo from '../assets/image/logo.jpeg';

const Preloader = () => {
    return (
        <div id="loading">
            <div id="loading-center">
                <div className="loader-container">
                    <div className="wrap-loader">
                        <div className="loader">
                        </div>
                        <div className="icon">
                            <img src={logo} alt="logo" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Preloader;
